/**
 * Module - Route / Menu - English
 * meta.title uses English keys; document.title via permission.js i18n.t('route.' + rawTitle)
 */
export default {
  route: {
    login: 'Login',
    redirecting: 'Redirecting',
    exportImport: 'Export & Import',
    noPermission: 'No Permission',
    pageNotFound: 'Page Not Found',
    purchaseOrders: 'Purchase Orders',
    transferGoodsManagement: 'Transfer Goods Management',
    creditOrders: 'Credit Orders',
    doubleOrders: 'Double Orders',
    createDoubleOrder: 'Create Double Order',
    headOfficeShipment: 'Head Office Shipment',
    regionalShipmentRecords: 'Regional Shipment Records',
    regionalJdWarehouseShipment: 'Regional JD Warehouse Shipment',
    cloudWarehouseShipmentDetails: 'Cloud Warehouse Shipment Details',
    accountSettlement: 'Account Settlement',
    accountAssetDashboard: 'Account Asset Dashboard',
    maintenanceManagement: 'Maintenance Management',
    callCenterConfig: 'Call Center Config',
    noviceTasks: 'Novice Tasks',
    dashboard: 'Dashboard',
    analystManagement: 'Analyst Management',
    accountManagement: 'Account Management',
    employeeAccounts: 'Employee Accounts',
    tools: 'Tools',
    organizationArchive: 'Organization Archive',
    goldAccountManagement: 'Gold Account Management',
    salesShipment: 'Sales Shipment',
    potentialCustomers: 'Potential Customers',
    leadManagement: 'Lead Management',
    targetManagement: 'Target Management',
    dataReports: 'Data Reports',
    studyMachineManagement: 'Study Machine Management',
    takeDelivery: 'Take Delivery',
    newLading: 'New Lading',
    ladingDetail: 'Lading Detail',
    barterManagement: 'Barter Management',
    teacherChildrenDevice: 'Teacher Children Device',
    childrenDeviceDetail: 'Children Device Detail',
    supervisorManagement: 'Supervisor Management',
    studentManagement: 'Student Management',
    addStudentList: 'Add Student List',
    scoreManagement: 'Score Management',
    supervisorData: 'Supervisor Data',
    supervisorDetails: 'Supervisor Details',
    supervisorSummary: 'Supervisor Summary',
    dataLibrary: 'Data Library',
    assignPermissions: 'Assign Permissions',
    customQuickIdentity: 'Custom Quick Identity',
    employeeLearningAccounts: 'Employee Learning Accounts',
    scoreCollectionTotal: 'Score Collection (Total)',
    supervisorScoreManagement: 'Supervisor Score Management',
    videoCallRecord: 'Video Call Record',
    targetSetting: 'Target Setting',
    performanceReview: 'Performance Review',
    basicSettings: 'Basic Settings'
  }
}
